import React, { Component } from 'react';
import { connect } from 'react-redux';
import CreateTransactionView from './CreateTransaction.view';

export class CreateTransactionContainer extends Component {

  constructor(props) {
    super(props);
    this.onFormUpdate = this.onFormUpdate.bind(this);
    this.submitForm = this.submitForm.bind(this);
    this.closeCreateModal = this.closeCreateModal.bind(this);
  }

  closeCreateModal() {
    const { dispatch } = this.props;
    dispatch({
      type: 'TOGGLE_MODAL',
      payload: {
        active: false,
      }
    });
  }

  onFormUpdate(formState, actions) {
    const { dispatch } = this.props;
    dispatch({
      type: 'ON_TRANSACTION_CREATE_FORM_UPDATE',
      payload: {
        formState,
      },
    });
  }

  submitForm(formState) {
    const { dispatch } = this.props;
    dispatch({
      type: 'CREATE_TRANSACTION',
      payload: {
        data: formState.data,
      },
    });
  }

  render() {
    return (<CreateTransactionView
      {...this.state}
      {...this.props}
      closeCreateModal={this.closeCreateModal}
      onFormUpdate={this.onFormUpdate}
      submitForm={this.submitForm}
    />);
  }

}

function mapStateToProps(state) {
  const { ledger } = state;
  return {
    createModalActive: ledger.createModalActive,
    formState: ledger.createFormState,
  };
}

export default connect(mapStateToProps)(CreateTransactionContainer);



// WEBPACK FOOTER //
// ./src/app/modules/WorkArea/Ledger/CreateTransaction/CreateTransaction.container.js